// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3hxuh","footer":"ModalInfo_footer__3LXEX"};